if(!customElements.get('pagination-button')){
    class ProductListPaginationButton extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.btnLoadMore = this.querySelector('.btn-load-more');

            if(this.closest('custom-search-product-list')){

                this.productList = this.closest('custom-search-product-list');
                this.productsWrapper = this.productList.querySelector('#search-item-list__items-wrapper');
                this.products = this.productList.querySelector('#search-item-list__items');
                this.content = 'search';

            }else if(this.closest('custom-collection-product-list')){

                this.productList = this.closest('custom-collection-product-list');
                this.productsWrapper = this.productList.querySelector('#collection-product-list__products-wrapper');
                this.products = this.productList.querySelector('#collection-product-list__products');
                this.content = 'collection';

            }
            
            this.btnColumnSwitch = this.productList.querySelector('.product-view-switch-wrapper');

            this.btnLoadMore.addEventListener('click', e => {
                e.preventDefault();

                this.btnLoadMore.setAttribute('data-disabled', 'true');
                this.loadMoreProducts();
            });

            this.btnLoadMore.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    e.preventDefault();

                    this.btnLoadMore.setAttribute('data-disabled', 'true');
                    this.loadMoreProducts();
                }
            })
        }

        async loadMoreProducts(options = {}){
            try{
                const nextPageRes = await fetch(
                    `${this.btnLoadMore.dataset.url}`
                );
                const nextPageText = await nextPageRes.text();
                const nextPageHTML = new DOMParser().parseFromString(nextPageText, 'text/html');

                const productsWrapper = this.content == 'collection'? 
                    nextPageHTML.querySelector('#collection-product-list__products-wrapper'):
                    nextPageHTML.querySelector('#search-item-list__items-wrapper');

                const products = this.content == 'collection'? 
                    productsWrapper.querySelector('#collection-product-list__products'):
                    productsWrapper.querySelector('#search-item-list__items');

                const btnLoadMore = productsWrapper.querySelector('.btn-load-more');

                // get product 
                const productCards = products.querySelectorAll('.product-card__wrapper, .article-card__wrapper, .page-card__wrapper');
                
                productCards.forEach(item => {
                    if(this.btnColumnSwitch.dataset.column == '3'){
                        item.classList.add('col-xl-3');
                        item.classList.add('col-6');
                        item.classList.remove('col-xl-4');
                        item.classList.remove('col-12');
                    }else{
                        item.classList.add('col-xl-4');
                        item.classList.add('col-12');
                        item.classList.remove('col-xl-3');
                        item.classList.remove('col-6');
                    }

                    this.products.appendChild(item);
                });

                if (options.focusFirst !== false && productCards.length > 0) {
                    setTimeout(() => {
                        if(productCards[0].querySelectorAll('.tab-able-item').length > 0){
                            productCards[0].querySelectorAll('.tab-able-item')[0].focus();
                        }
                    }, 100);
                }

                if(btnLoadMore){
                    this.btnLoadMore.classList.remove('d-none');
                    this.btnLoadMore.setAttribute('data-url', `${btnLoadMore.dataset.url}`);
                }else{
                    this.btnLoadMore.classList.add('d-none');
                }

                // add swatch checked
                const variantSwatchSelector = this.products.querySelectorAll('variant-swatch-selector');
                if(variantSwatchSelector.length > 0){
                    variantSwatchSelector.forEach(item => {
                        item.loadCheckedRadioInput();
                    });
                }
            } catch (error){

                console.error(error);
                if(!options.silent) alert(error.message);
                return false;

            } finally {
                this.btnLoadMore.setAttribute('data-disabled', 'false');
            }

            return true;
        }
    }

    customElements.define('pagination-button', ProductListPaginationButton);
}
